import { RouteObject, Navigate } from 'react-router-dom';
import { CoreRoutes } from './modules/core';
import { AttendanceRoutes } from './modules/attendance';
import { PayrollRoutes } from './modules/payroll';
import { PerformanceRoutes } from './modules/performance';
import { RecruitingRoutes } from './modules/recruiting';
import { SelfserviceRoutes } from './modules/selfservice';
import { ComplianceRoutes } from './modules/compliance';

export const peopleRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="core/employees" replace /> },
  CoreRoutes,
  AttendanceRoutes,
  PayrollRoutes,
  PerformanceRoutes,
  RecruitingRoutes,
  SelfserviceRoutes,
  ComplianceRoutes,
  { path: 'employees', element: <Navigate to="core/employees" replace />, handle: { crumb: 'Workforce' } },
  { path: 'org-chart', element: <Navigate to="core/org-chart" replace />, handle: { crumb: 'Org Hierarchy' } },
  { path: 'leaves', element: <Navigate to="attendance/attendance" replace />, handle: { crumb: 'Time Off' } },
];

export default peopleRoutes;
